import { PickListItem, JsonItem, AppUserAffiliation, RevamppCore, RevamppProject, AppUserExtended } from "../list-management.objects"; 
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

export class UserAffiliationSelctor implements SpecialCaseEntity {
    id: string;
    sectionId: string;
    propertyName: string;
    rolePickListName: string;
    centerPickListName: string;
    corePickListName: string;
    projectPickListName: string;

    isRequired: boolean;
    displayName: string;

    roleList: PickListItem[];
    centerList: PickListItem[];
    coreList: RevamppCore[];
    projectList: RevamppProject[];

    affiliationTable: any;
    initialAffiliations: AppUserAffiliation[];
    addedAffiliations: AppUserAffiliation[];

    currentAppUser: AppUserExtended = null;

    constructor(id: string, propteryName: string, roleListName: string, additionalPickLists: string[], displayName: string, isRequired: boolean) {
        this.id = id;
        this.sectionId = `user-affiliation-${this.id}`;
        this.propertyName = propteryName;
        this.rolePickListName = roleListName;
        this.centerPickListName = additionalPickLists.find(pl => pl.includes("center"));
        this.corePickListName = additionalPickLists.find(pl => pl.includes("core"));
        this.projectPickListName = additionalPickLists.find(pl => pl.includes("project"));
        this.addedAffiliations = [];
        this.initialAffiliations = [];
        this.displayName = displayName;
        this.isRequired = isRequired;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";
        let displayNameHtml = "";
        if (this.displayName) {
            displayNameHtml = `<div><label for="" class="${requiredClass}">${this.displayName}</label></div>`
        }

        let html = `
            ${displayNameHtml}
            <p>Use the affiliation tool below to modify any ReVAMPP affiliations. To add an affiliation, select a role, center, and core/project from the dropdown options and then click "Add Affiliation." To remove an affiliation, expand it in the list by clicking on it, then click "Remove Affiliation."</p>
            <p id="${this.id}-error-msg" class='d-none text-danger'>Please add at least one ReVAMPP affiliation.</p>
            <div class="user-affiliation-selection-block mb-4" id="user-affiliation-${this.id}">
                <div class="reset-section-block d-flex justify-content-between align-items-center py-2 px-3">
                    <div id="user-display-title-${this.id}" class="reset-section-title d-none">
                        
                    </div>
                    <div class="reset-user-affiliation">
                        <a id="reset-user-affiliation-btn-${this.id}" class="btn btn-secondary revampp-white-btn font-size14">
                            Reset
                        </a>
                    </div>
                </div>
                <div class="add-user-affiliation-block py-3">
                    <div class="row px-3">
                        <div class="col-md-6 col-12 affiliation-block-form">
                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">Role:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-role-select-${this.id}" title="-- Select a Role --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">ReVAMPP Center:</label>
                                    <p class='form-text mb-0 mt-0'>Please select a ReVAMPP Center prior to selecting a Core or Project.</p>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-center-select-${this.id}" title="-- Select ReVAMPP Center --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="form-group col mb-0" id="core-project-select-${this.id}">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="projectCoreOptions" id="core-radio-${this.id}" value="core" checked>
                                        <label class="form-check-label" for="core-radio-${this.id}">Core</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="projectCoreOptions" id="project-radio-${this.id}" value="project">
                                        <label class="form-check-label" for="project-radio-${this.id}">Project</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="projectCoreOptions" id="other-radio-${this.id}" value="other">
                                        <label class="form-check-label" for="other-radio-${this.id}">N/A</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2" id="core-select-block-${this.id}">
                                <div class="form-group col">
                                    <label class="mb-0">Core Name:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-core-select-${this.id}" title="-- Select a ReVAMPP Core --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2 d-none" id="project-select-block-${this.id}">
                                <div class="form-group col">
                                    <label class="mb-0">Project Name:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-project-select-${this.id}" title="-- Select a ReVAMPP Project --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-auto">
                                    <a class="btn btn-small revampp-blue-btn text-decoration-none add-affiliation-btn" id="add-affiliation-btn-${this.id}">+ Add Affiliation</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12 affiliation-block-list mt-md-0 mt-3">
                            <div>
                                <div class="mb-1">
                                    <span class="font-weight-bold">Added Affiliations: </span><span id="added-affiliations-count-${this.id}">0</span>
                                </div>
                                <div class="revampp-affiliation-list-section">

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            `
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.centerList = [];
        this.coreList = [];
        this.projectList = [];
        this.roleList = [];

        let foundCenterList = pickLists.find(list => list.Id == this.centerPickListName);
        let foundCoreList = pickLists.find(list => list.Id == this.corePickListName);
        let foundProjectList = pickLists.find(list => list.Id == this.projectPickListName);
        let foundRoleList = pickLists.find(list => list.Id == this.rolePickListName);

        if (!foundCenterList || !foundCoreList || !foundProjectList || !foundRoleList) return;

        this.centerList = foundCenterList.Json;
        this.coreList = foundCoreList.Json;
        this.projectList = foundProjectList.Json;
        this.roleList = foundRoleList.Json;

        // Dropdown for Roles + Centers
        let centerArr: string[][] = [];
        this.centerList.forEach(center => centerArr.push([center.Value, center.Id.toString()]));
        let roleArr: string[][] = [];
        this.roleList.forEach(role => roleArr.push([role.Value, role.Id.toString()]));
        this.generateDropdown(`revampp-center-select-${this.id}`, centerArr);
        this.generateDropdown(`revampp-role-select-${this.id}`, roleArr);
        this.generateDropdown(`revampp-core-select-${this.id}`, []);
        this.generateDropdown(`revampp-project-select-${this.id}`, []);

        //initialize table
        this.clearAffiliationList();

        // initialize Search functionality
        this.initializeSearchTool();

        if (entityArr.length > 0) {
            // access are only done with one user
            this.currentAppUser = entityArr[0];
        }

        this.updateDisplayUser();
    }

    updateDisplayUser(): void {
        let displayBlock: JQuery<HTMLElement> = $(`#user-display-title-${this.id}`);
        displayBlock.addClass("d-none");

        if (this.currentAppUser) {
            let name = `${this.currentAppUser.AppUser.FirstName} ${this.currentAppUser.AppUser.LastName}`;
            displayBlock.text(name);
            displayBlock.removeClass("d-none");
        }
    }

    getValue(): any {
        return this.addedAffiliations;
    }

    validate(): boolean {
        if (!this.isRequired) {
            this.displayValid(true);
            return true;
        }
        else {
            if (this.addedAffiliations.length == 0) {
                this.displayValid(false);
                return false;
            }
            else {
                this.displayValid(true);
                return true;
            }
        }
    }

    displayValid(isValid: boolean) {
        let errorMsg = $(`#${this.id}-error-msg`);

        if (isValid) {
            errorMsg.addClass("d-none");
        }
        else {
            errorMsg.removeClass("d-none");
        }
    }

    getDisplayRole(roleId: number): string {
        let returnVal = "";
        let foundRole = this.roleList.find(role => role.Id == roleId);

        if (foundRole) {
            returnVal = foundRole.Value;
        }
        else if (roleId <= 4 && !foundRole) {
            if (roleId == 1) returnVal = "Center PI (Contact)";
            else if (roleId == 2) returnVal = "Center mPI/coPI";
            else if (roleId == 3) returnVal = "Project Leader";
            else if (roleId == 4) returnVal = "Core Leader";
            else if (roleId == 0) returnVal = "--Not Specified--"
        }

        return returnVal;
    }

    allowedDeleteRole(roleId: number): boolean {
        let foundRole = this.roleList.find(role => role.Id == roleId);
        if (foundRole) {
            return true;
        }
        else if (roleId == 0) {
            return true;
        }
        return false;
    }

    getDisplayCenter(centerId: number): string {
        let returnVal = "";
        let foundCenter = this.centerList.find(center => center.Id == centerId);
        if (foundCenter) {
            returnVal = foundCenter.Value;
        }
        return returnVal;
    }

    getDisplayCore(coreId: number): string {
        let returnVal = "";
        let foundCore = this.coreList.find(core => core.Id == coreId);
        if (foundCore) {
            returnVal = foundCore.CoreName;
        }
        return returnVal;
    }

    getDisplayProject(projectId: number): string {
        let returnVal = "";
        let foundProject = this.projectList.find(project => project.Id == projectId);
        if (foundProject) {
            returnVal = foundProject.ProjectName;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        // This isn't going to work for mulitple items;
        if (entityArray.length <= 0) return;
        let targetEntity = entityArray[0];
        let initialValues = _.get(targetEntity, this.propertyName);

        this.initialAffiliations = _.cloneDeep(initialValues);
        this.addedAffiliations = _.cloneDeep(initialValues);

        this.updateAffiliationsList();
    }

    checkChanged(): boolean {
        //return _.isEqual(this.initialPathogens, this.addedPathogens);
        return true;
    }

    clearAffiliationList(): void {
        $(`#${this.sectionId}`).find(".revampp-affiliation-list-section").empty();
    }

    updateAffiliationsList(): void {
        this.clearAffiliationList();
        let affiliationListHtml = "";
        for (let i = 0; i < this.addedAffiliations.length; i++) {
            let currentAffiliation: AppUserAffiliation = this.addedAffiliations[i];

            let coreContent = "";
            if (currentAffiliation.CoreId > 0) {
                coreContent = `
                    <div>
                        <b>Core</b>: ${this.getDisplayCore(currentAffiliation.CoreId)} 
                    </div>
                `
            }
            let projectContent = "";
            if (currentAffiliation.ProjectId > 0) {
                projectContent = `
                    <div>
                        <b>Project</b>: ${this.getDisplayProject(currentAffiliation.ProjectId)} 
                    </div>
                `
            }

            let deleteButton = "";
            if (this.allowedDeleteRole(currentAffiliation.RoleId)) {
                deleteButton = `
                    <div class="mt-2">
                        <a class="btn btn-small revampp-white-btn text-decoration-none delete-affiliation-btn" id="delete-affiliation-btn-${i}">Remove Affiliation</a>
                    </div>
                `
            }

            let expandContent = `
                <div id="affiliation-list-collapse-${i}" class="collapse p-1">
                    <div>
                        <b>Role</b>: ${this.getDisplayRole(currentAffiliation.RoleId)} 
                    </div>
                    <div>
                        <b>Center</b>: ${this.getDisplayCenter(currentAffiliation.CenterId)} 
                    </div>
                    ${coreContent}
                    ${projectContent}
                    ${deleteButton}
                </div>
            `

            affiliationListHtml += `
                <div class="affiliation-list-item">
                    <div class="affiliation-item-block collapsed" data-toggle="collapse" data-target="#affiliation-list-collapse-${i}">
                        <div class="affiliation-block-title">
                            ${this.getDisplayRole(currentAffiliation.RoleId)}
                        </div>
                    </div>
                    ${expandContent}
                </div>
            `
        }

        $(`#${this.sectionId}`).find(".revampp-affiliation-list-section").html(affiliationListHtml);
        $(`#added-affiliations-count-${this.id}`).text(this.addedAffiliations.length);

        $(`#${this.sectionId}`).find(".delete-affiliation-btn").off().on("click", (e) => {
            let elementId = $(e.currentTarget).attr("id");
            let arrayIndex: number = parseInt(elementId.replace("delete-affiliation-btn-", ""));
            if (arrayIndex != NaN) {
                this.addedAffiliations.splice(arrayIndex, 1);
                this.updateAffiliationsList();
            }
        })
    }

    initializeSearchTool(): void {
        // Reset Dropdowns
        $(`#reset-user-affiliation-btn-${this.id}`).on('click', (e) => {
            this.clearValidation();
            this.resetDropdowns();
        });

        // Change Center Name
        $(`#revampp-center-select-${this.id}`).on('changed.bs.select', (e) => {
            // Get Selected Center
            let searchedCenter = $(`#revampp-center-select-${this.id}`).val();

            // Clear existing options
            $(`#revampp-core-select-${this.id}`).empty();
            $(`#revampp-project-select-${this.id}`).empty();

            // Create Dropdown options for Core/Project
            let foundCenter = this.centerList.find(center => center.Id.toString() == searchedCenter.toString());
            if (foundCenter != undefined) {

                let foundCores = this.coreList.filter(core => core.CenterId == foundCenter.Id);
                foundCores.sort((x1, x2) => x1.CoreName.localeCompare(x2.CoreName));
                foundCores.forEach(core => {
                    $(`#revampp-core-select-${this.id}`).append(`<option value="${core.Id}">${core.CoreName}</option>`)
                });

                let foundProjects = this.projectList.filter(project => project.CenterId == foundCenter.Id);
                foundProjects.sort((x1, x2) => x1.ProjectName.localeCompare(x2.ProjectName));
                foundProjects.forEach(project => {
                    $(`#revampp-project-select-${this.id}`).append(`<option value="${project.Id}">${project.ProjectName}</option>`)
                });

                // If no cores or projects, automatically select 'N/A'
                if (foundCores.length == 0 && foundProjects.length == 0) {
                    $(`#other-radio-${this.id}`).prop("checked", true).trigger("change");
                }
                else {
                    $(`#core-radio-${this.id}`).prop("checked", true).trigger("change");
                }
            }

            //$(`#add-affiliation-btn-${this.id}`).addClass("disabled");

            $(`#revampp-core-select-${this.id}`).selectpicker("refresh");
            $(`#revampp-project-select-${this.id}`).selectpicker("refresh");
        });

        // On Radio Select
        $(`#core-project-select-${this.id}`).on('change', (e) => {
            if ($(`#core-radio-${this.id}`).is(":checked")) {
                $(`#revampp-project-select-${this.id}`).selectpicker("val", "");
                $(`#core-select-block-${this.id}`).removeClass("d-none");
                $(`#project-select-block-${this.id}`).addClass("d-none");
            }
            else if ($(`#project-radio-${this.id}`).is(":checked")) {
                $(`#revampp-core-select-${this.id}`).selectpicker("val", "");
                $(`#core-select-block-${this.id}`).addClass("d-none");
                $(`#project-select-block-${this.id}`).removeClass("d-none");
            }
            else if ($(`#other-radio-${this.id}`).is(":checked")) {
                $(`#revampp-core-select-${this.id}`).selectpicker("val", "");
                $(`#revampp-project-select-${this.id}`).selectpicker("val", "");
                $(`#core-select-block-${this.id}`).addClass("d-none");
                $(`#project-select-block-${this.id}`).addClass("d-none");
            }

        });

        $(`#revampp-project-select-${this.id}`).on("changed.bs.select", () => {
            let currentVal = $(`#revampp-project-select-${this.id}`).val();
            if (currentVal) {
                //$(`#add-affiliation-btn-${this.id}`).removeClass("disabled");
            }
        });

        $(`#revampp-core-select-${this.id}`).on("changed.bs.select", () => {
            let currentVal = $(`#revampp-core-select-${this.id}`).val();
            if (currentVal) {
                //$(`#add-affiliation-btn-${this.id}`).removeClass("disabled");
            }
        });

        $(`#add-affiliation-btn-${this.id}`).on('click', () => {
            // Validate
            let isValid: boolean = this.validateAffiliationForm();
            if (!isValid) return;

            // Get Affiliation
            let roleId = parseInt($(`#revampp-role-select-${this.id}`).val().toString());
            let centerId = parseInt($(`#revampp-center-select-${this.id}`).val().toString());
            let coreId = parseInt($(`#revampp-core-select-${this.id}`).val().toString());
            let projectId = parseInt($(`#revampp-project-select-${this.id}`).val().toString());

            if (!coreId) coreId = 0;
            if (!projectId) projectId = 0;

            let newAffiliation: AppUserAffiliation = {
                Id: 0,
                AppUserId: 0,
                RoleId: roleId,
                CenterId: centerId,
                CoreId: coreId,
                ProjectId: projectId
            }

            // Add Affiliation to List of Affilliations (no duplicates)
            let foundAffiliation = this.addedAffiliations.find(affiliation => affiliation.RoleId == newAffiliation.RoleId && affiliation.CenterId == newAffiliation.CenterId && affiliation.CoreId == newAffiliation.CoreId && affiliation.ProjectId == newAffiliation.ProjectId);
            if (!foundAffiliation) {
                this.addedAffiliations.push(newAffiliation);
            }

            // Update Added Affiliations List
            this.updateAffiliationsList();
            this.resetDropdowns();
            this.clearValidation();
        })
    }

    validateAffiliationForm(): boolean {
        let isValid = true;

        // Role
        let roleSelected = $(`#revampp-role-select-${this.id}`).val();
        if (!roleSelected) {
            $(`#revampp-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        // Center
        let centerSelected = $(`#revampp-center-select-${this.id}`).val();
        if (!centerSelected) {
            $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        // Core + Project
        let coreSelected = $(`#revampp-core-select-${this.id}`).val();
        let projectSelected = $(`#revampp-project-select-${this.id}`).val()
        if (!coreSelected && !projectSelected) {
            if (!$(`#other-radio-${this.id}`).is(":checked")) {
                $(`#revampp-core-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
                $(`#revampp-project-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
                isValid = false;
            }     
        }
        else {
            $(`#revampp-core-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
            $(`#revampp-project-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        return isValid;
    }

    clearValidation() {
        $(`#revampp-center-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        $(`#revampp-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        $(`#revampp-core-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        $(`#revampp-project-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    resetDropdowns() {
        $(`#revampp-center-select-${this.id}`).val("").trigger("change");
        $(`#revampp-role-select-${this.id}`).val("").trigger("change");
    }

    generateDropdown(dropdownId: string, options: string[][]): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        if (options != undefined) {
            options.sort((x1: string[], x2: string[]) => {
                if (x1[0].startsWith("-") && !x2[0].startsWith("-")) {
                    return 1;
                }
                else if (x2[0].startsWith("-") && !x1[0].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[0].localeCompare(x2[0]);
                }
            });
            options.forEach((element: string[]) => {
                $(`#${dropdownId}`).append(new Option(element[0], element[1], false, false))
            })
        }

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getDisplayValue(indexVal = -1): string {
        return "";
    }
}